// extracted by mini-css-extract-plugin
export var contrastLow = "_2g-1";
export var externalLink = "_2g-2";
export var externalLinkIcon = "_2g-3";
export var link = "_2g-0";
export var linkLabel = "_2g-4";